import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { CustomMDXEditor } from "@/components/shared";

export const executiveSummarySchema = z.object({
  executiveSummary: z.string().optional().or(z.literal("")),
});

export const executiveSummaryDefaultValues = {
  executiveSummary: "",
};

export function ExecutiveSummaryFormGroup({
  form,
}: {
  form: UseFormReturn<any>;
}) {
  const { t } = useTranslation(["components", "common"]);
  const { setValue, getValues } = form;
  const executiveSummary = getValues("executiveSummary") ?? "";

  return (
    <div>
      <div id="executivesummary">
        <CustomMDXEditor
          autoFocus={false}
          value={executiveSummary}
          onChange={(value) => setValue("executiveSummary", value)}
          placeholder={t("common:optional")}
          overwriteDefaultClasses={true}
          editableContentClassName="h-[calc(100vh-18rem)] overflow-y-auto p-4 border-[1px] border-gray-300 rounded-md"
        />
      </div>
    </div>
  );
}
